import { Table, Tag, Tooltip } from "antd";

// 🔥 Helpers
const formatNumber = (value) => {
  if (!value) return "0";
  return Number(value).toLocaleString("es-CO", {
    maximumFractionDigits: 2
  });
};

const formatCurrency = (value) => {
  if (!value) return "$0";
  return `$${Number(value).toLocaleString("es-CO", {
    maximumFractionDigits: 0
  })}`;
};

const formatDate = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("es-CO");
};

export default function DetalleTable({ data }) {
  const columns = [
    {
      title: "#",
      width: 60,
      align: "center",
      render: (_, __, index) => index + 1
    },
    {
      title: "Fecha",
      dataIndex: "fecha_entrega",
      width: 100,
      render: (v) => formatDate(v)
    },
    {
      title: "Cantidad",
      dataIndex: "cantidad",
      align: "center",
      width: 100,
      render: (v) => formatNumber(v)
    },
    {
      title: "Valor Unitario",
      align: "right",
      width: 120,
      render: (_, r) => formatCurrency(r.valor_unitario_COP)
    },
    {
      title: "Valor Total",
      align: "right",
      width: 120,
      render: (_, r) => (
        <Tooltip title="Valor total de esta entrega">
          <span style={{ fontWeight: 600 }}>
            {formatCurrency(r.valor_total)}
          </span>
        </Tooltip>
      )
    },
    {
      title: "% Entrega",
      dataIndex: "porcentaje_entrega",
      align: "center",
      width: 120,
      render: (v) => (
        <Tag color={Number(v) === 100 ? "green" : "blue"}>
          {Number(v)}%
        </Tag>
      )
    },
    {
      title: "Unidad",
      dataIndex: "unidad_medida",
      align: "center",
      width: 100,
    }
  ];

  return (
    <Table
      style={{ paddingTop: 20, paddingBottom: 20}}
      columns={columns}
      dataSource={data}
      pagination={false}
      rowKey="oid"
      size="small"
    />
  );
}